import * as React from "react";
import {AdminAnalyticsApi} from "../../../../api/AdminAnalyticsApi";
import {LoadingSpinner} from "../../../icons/LoadingSpinner.component";
import {DEFAULT_HEALTH} from "../shared/analytics.constants";
import {useAnalyticsTabData} from "../hooks/useAnalyticsTabData";
import {RetentionSection} from "./RetentionSection.component";
import {InactiveUsersTable} from "./InactiveUsersTable.component";

interface IHealthTabProps {
    range: { startDate: string; endDate: string };
    country: string;
}

export const HealthTab: React.FC<IHealthTabProps> = (props) => {
    const {data, loading, error} = useAnalyticsTabData(
        "health",
        (startDate, endDate, c) => AdminAnalyticsApi.getHealthTab(startDate, endDate, c),
        props.range,
        props.country,
        DEFAULT_HEALTH,
    );

    if (loading) {
        return <div className="admin-analytics__tab-loading"><LoadingSpinner/></div>;
    }
    if (error) {
        return <div className="admin-analytics__error">{error}</div>;
    }

    return (
        <div>
            {data.retention.length > 0 && <RetentionSection retention={data.retention}/>}
            {data.inactiveCount > 0 && (
                <InactiveUsersTable inactiveUsers={data.inactiveUsers} inactiveCount={data.inactiveCount}/>
            )}
        </div>
    );
};
